import React, { useState, useEffect } from 'react';

function WorkshopsManager() {
    const [workshops, setWorkshops] = useState([]);
    const [bookings, setBookings] = useState({});
    const [showForm, setShowForm] = useState(false);
    const [editingWorkshop, setEditingWorkshop] = useState(null);
    // No more tabs - show all workshops
    const [expandedWorkshop, setExpandedWorkshop] = useState(null);
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        target_audience: 'kinder',
        date: '',
        time: '10:00',
        duration: 120,
        max_participants: 10,
        price: 0,
        price_sibling: '',
        price_member: '',
        price_member_sibling: '',
        location: '',
        open_event: false,
        dates_display: ''
    });

    useEffect(() => {
        fetchWorkshops();
    }, []);

    const fetchWorkshops = () => {
        setLoading(true);
        fetch('/api/workshops')
            .then(res => res.json())
            .then(data => {
                setWorkshops(data.data || []);
                setLoading(false);
            })
            .catch(err => {
                console.error('Fehler:', err);
                setLoading(false);
            });
    };

    const fetchBookings = (workshopId) => {
        fetch(`/api/workshops/${workshopId}/bookings`)
            .then(res => res.json())
            .then(data => {
                setBookings(prev => ({ ...prev, [workshopId]: data.data || [] }));
            })
            .catch(err => console.error('Fehler:', err));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const url = editingWorkshop
            ? `/api/workshops/${editingWorkshop.id}`
            : '/api/workshops';
        const method = editingWorkshop ? 'PUT' : 'POST';

        fetch(url, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    fetchWorkshops();
                    resetForm();
                } else {
                    alert(data.error || 'Fehler beim Speichern');
                }
            })
            .catch(err => alert('Fehler: ' + err.message));
    };

    const handleDelete = (id) => {
        if (!window.confirm('Workshop wirklich loeschen?')) return;

        fetch(`/api/workshops/${id}`, { method: 'DELETE' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    fetchWorkshops();
                } else {
                    alert(data.error || 'Fehler beim Loeschen');
                }
            })
            .catch(err => alert('Fehler: ' + err.message));
    };

    const handleDeleteBooking = (bookingId, workshopId) => {
        if (!window.confirm('Buchung wirklich stornieren?')) return;

        fetch(`/api/workshop-bookings/${bookingId}`, { method: 'DELETE' })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    fetchBookings(workshopId);
                    fetchWorkshops();
                }
            })
            .catch(err => alert('Fehler: ' + err.message));
    };

    const toggleActive = (workshop) => {
        fetch(`/api/workshops/${workshop.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ active: !workshop.active })
        })
            .then(res => res.json())
            .then(data => {
                if (data.message === 'success') {
                    fetchWorkshops();
                }
            })
            .catch(err => alert('Fehler: ' + err.message));
    };

    const startEdit = (workshop) => {
        setEditingWorkshop(workshop);
        setFormData({
            title: workshop.title,
            description: workshop.description || '',
            target_audience: workshop.target_audience,
            date: workshop.date,
            time: workshop.time?.substring(0, 5) || '10:00',
            duration: workshop.duration || 120,
            max_participants: workshop.max_participants || 10,
            price: workshop.price || 0,
            price_sibling: workshop.price_sibling || '',
            price_member: workshop.price_member || '',
            price_member_sibling: workshop.price_member_sibling || '',
            location: workshop.location || '',
            open_event: workshop.open_event || false,
            dates_display: workshop.dates_display || ''
        });
        setShowForm(true);
    };

    const resetForm = () => {
        setShowForm(false);
        setEditingWorkshop(null);
        setFormData({
            title: '',
            description: '',
            target_audience: 'kinder',
            date: '',
            time: '10:00',
            duration: 120,
            max_participants: 10,
            price: 0,
            price_sibling: '',
            price_member: '',
            price_member_sibling: '',
            location: '',
            open_event: false,
            dates_display: ''
        });
    };

    const toggleExpand = (workshopId) => {
        if (expandedWorkshop === workshopId) {
            setExpandedWorkshop(null);
        } else {
            setExpandedWorkshop(workshopId);
            if (!bookings[workshopId]) {
                fetchBookings(workshopId);
            }
        }
    };

    const formatDate = (dateStr) => {
        return new Date(dateStr).toLocaleDateString('de-DE', {
            weekday: 'short',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Show all workshops, sorted by date
    const sortedWorkshops = [...workshops].sort((a, b) => new Date(a.date) - new Date(b.date));

    if (loading) {
        return <div className="text-center py-5"><div className="spinner-border"></div></div>;
    }

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4>Workshops & Events verwalten</h4>
                <button
                    className="btn btn-primary"
                    onClick={() => setShowForm(true)}
                >
                    + Neuer Workshop
                </button>
            </div>


            {/* Workshop Form */}
            {showForm && (
                <div className="card mb-4">
                    <div className="card-header">
                        <h5 className="mb-0">{editingWorkshop ? 'Workshop bearbeiten' : 'Neuer Workshop'}</h5>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-8 mb-3">
                                    <label className="form-label">Titel *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.title}
                                        onChange={e => setFormData({ ...formData, title: e.target.value })}
                                        required
                                        placeholder="z.B. KI-Workshop fuer Einsteiger"
                                    />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Zielgruppe *</label>
                                    <select
                                        className="form-select"
                                        value={formData.target_audience}
                                        onChange={e => setFormData({ ...formData, target_audience: e.target.value })}
                                    >
                                        <option value="kinder">Fuer Kinder</option>
                                        <option value="erwachsene">Fuer Erwachsene</option>
                                        <option value="alle">Fuer Alle</option>
                                    </select>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Beschreibung</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={formData.description}
                                    onChange={e => setFormData({ ...formData, description: e.target.value })}
                                    placeholder="Was erwartet die Teilnehmer?"
                                />
                            </div>

                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Datum *</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData.date}
                                        onChange={e => setFormData({ ...formData, date: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Termine-Anzeige (optional)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.dates_display}
                                        onChange={e => setFormData({ ...formData, dates_display: e.target.value })}
                                        placeholder="z.B. 4x Sa: 20.06. | 27.06. | 04.07. | 11.07."
                                    />
                                    <small className="text-muted">Wird statt dem Einzeldatum angezeigt</small>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Uhrzeit *</label>
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={formData.time}
                                        onChange={e => setFormData({ ...formData, time: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Dauer (Min.)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={formData.duration}
                                        onChange={e => setFormData({ ...formData, duration: parseInt(e.target.value) })}
                                        min="30"
                                        step="30"
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Max. Teilnehmer</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={formData.max_participants}
                                        onChange={e => setFormData({ ...formData, max_participants: parseInt(e.target.value) })}
                                        min="1"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Preis (EUR)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={formData.price}
                                        onChange={e => setFormData({ ...formData, price: parseFloat(e.target.value) })}
                                        min="0"
                                        step="0.01"
                                        placeholder="z.B. 120"
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Geschwister (EUR)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={formData.price_sibling}
                                        onChange={e => setFormData({ ...formData, price_sibling: e.target.value ? parseFloat(e.target.value) : '' })}
                                        min="0"
                                        step="0.01"
                                        placeholder="z.B. 105"
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Mitglieder (EUR)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={formData.price_member}
                                        onChange={e => setFormData({ ...formData, price_member: e.target.value ? parseFloat(e.target.value) : '' })}
                                        min="0"
                                        step="0.01"
                                        placeholder="z.B. 110"
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label className="form-label">Mitgl. Geschw. (EUR)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={formData.price_member_sibling}
                                        onChange={e => setFormData({ ...formData, price_member_sibling: e.target.value ? parseFloat(e.target.value) : '' })}
                                        min="0"
                                        step="0.01"
                                        placeholder="z.B. 95"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label className="form-label">Ort</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.location}
                                        onChange={e => setFormData({ ...formData, location: e.target.value })}
                                        placeholder="z.B. Futurhinos Studio"
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="open_event"
                                        checked={formData.open_event}
                                        onChange={e => setFormData({ ...formData, open_event: e.target.checked })}
                                    />
                                    <label className="form-check-label" htmlFor="open_event">
                                        <strong>Offenes Event</strong> - ohne Anmeldung, einfach vorbeikommen
                                    </label>
                                </div>
                            </div>

                            <div className="d-flex gap-2">
                                <button type="submit" className="btn btn-success">
                                    {editingWorkshop ? 'Speichern' : 'Workshop erstellen'}
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={resetForm}>
                                    Abbrechen
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Workshop List */}
            {sortedWorkshops.length === 0 ? (
                <div className="alert alert-info">
                    Noch keine Workshops angelegt.
                </div>
            ) : (
                <div className="list-group">
                    {sortedWorkshops.map(workshop => (
                        <div key={workshop.id} className="list-group-item">
                            <div className="d-flex justify-content-between align-items-start">
                                <div className="flex-grow-1" onClick={() => toggleExpand(workshop.id)} style={{ cursor: 'pointer' }}>
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <h6 className="mb-0">{workshop.title}</h6>
                                        <span className={`badge ${workshop.target_audience === 'kinder' ? 'bg-warning text-dark' : workshop.target_audience === 'alle' ? 'bg-success' : 'bg-primary'}`}>
                                            {workshop.target_audience === 'kinder' ? 'Kinder' : workshop.target_audience === 'alle' ? 'Alle' : 'Erwachsene'}
                                        </span>
                                        {workshop.open_event && <span className="badge bg-info">Offen</span>}
                                        {!workshop.active && <span className="badge bg-secondary">Inaktiv</span>}
                                        {!workshop.open_event && workshop.booked_count > 0 && (
                                            <span className="badge bg-info">
                                                {workshop.booked_count}/{workshop.max_participants} gebucht
                                            </span>
                                        )}
                                    </div>
                                    <div className="small text-muted">
                                        {formatDate(workshop.date)} um {workshop.time?.substring(0, 5)} Uhr
                                        {workshop.duration && ` (${workshop.duration} Min.)`}
                                        {workshop.price > 0 && ` - ${parseFloat(workshop.price).toFixed(2)} EUR`}
                                    </div>
                                    {workshop.description && (
                                        <p className="small mb-0 mt-1 text-muted">
                                            {workshop.description.substring(0, 100)}
                                            {workshop.description.length > 100 && '...'}
                                        </p>
                                    )}
                                </div>
                                <div className="d-flex gap-1">
                                    <button
                                        className={`btn btn-sm ${workshop.active ? 'btn-outline-warning' : 'btn-outline-success'}`}
                                        onClick={() => toggleActive(workshop)}
                                        title={workshop.active ? 'Deaktivieren' : 'Aktivieren'}
                                    >
                                        {workshop.active ? 'Aus' : 'An'}
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => startEdit(workshop)}
                                    >
                                        Bearbeiten
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleDelete(workshop.id)}
                                    >
                                        Loeschen
                                    </button>
                                </div>
                            </div>

                            {/* Expanded Bookings */}
                            {expandedWorkshop === workshop.id && (
                                <div className="mt-3 pt-3 border-top">
                                    <h6>Buchungen</h6>
                                    {!bookings[workshop.id] ? (
                                        <div className="spinner-border spinner-border-sm"></div>
                                    ) : bookings[workshop.id].length === 0 ? (
                                        <p className="text-muted small">Noch keine Buchungen.</p>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>E-Mail</th>
                                                        <th>Teilnehmer</th>
                                                        <th>Gebucht am</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookings[workshop.id].map(booking => (
                                                        <tr key={booking.id}>
                                                            <td>{booking.name}</td>
                                                            <td>{booking.email}</td>
                                                            <td>{booking.participants || 1}</td>
                                                            <td>{new Date(booking.created_at).toLocaleDateString('de-DE')}</td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={() => handleDeleteBooking(booking.id, workshop.id)}
                                                                >
                                                                    Stornieren
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default WorkshopsManager;
